export default __webpack_public_path__ + "static/media/IMG_5572.1f559b9e.jpg";